import { preloadDraft } from '@confluence/fabric-providers/entry-points/preloadDraft';
import type { RouteMatch } from '@confluence/route';

export async function preloadEditPageRoutePostSSR(match: RouteMatch, _url: string) {
	const { contentId } = match.params;

	await preloadDraft(contentId);
}
